import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPriceCheckList, IPriceCheckListRequest } from '../models/models'

export class ExcelToProductPricesReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/Excel/productPriceReport',
      requesterInfo,
    })
  }

  public async excelToProductPricesReport(request: IPriceCheckListRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
